import React, { useEffect, useState } from 'react';
import { useAuth } from '../../../context/AuthContext';
import { patchCompany } from '../../../api/company/company';
import { isSelfServiceAssignmentEnabled } from './employeeSelfServiceAssignmentUtils';
import './service-staff-assignment.css';

const EmployeeSelfServiceAssignmentSettingsRow = () => {
  const { user, companyData, updateCompanyData } = useAuth();
  const isOwner = String(user?.role || '').toLowerCase() === 'owner';
  const [enabled, setEnabled] = useState(() => isSelfServiceAssignmentEnabled(companyData));
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setEnabled(isSelfServiceAssignmentEnabled(companyData));
  }, [companyData?.settings?.allowEmployeeSelfServiceAssignment]);

  if (!isOwner) {
    return null;
  }

  const handleChange = async (event) => {
    const nextValue = event.target.checked;
    setEnabled(nextValue);

    if (!companyData?.id) {
      return;
    }

    try {
      setSaving(true);
      const nextCompany = await patchCompany({
        companyId: companyData.id,
        company: {
          settings: {
            ...(companyData.settings || {}),
            allowEmployeeSelfServiceAssignment: nextValue,
          },
        },
      });
      updateCompanyData?.(nextCompany || {
        ...companyData,
        settings: {
          ...(companyData.settings || {}),
          allowEmployeeSelfServiceAssignment: nextValue,
        },
      });
    } catch (error) {
      console.error('Failed to update employee self-service assignment setting:', error);
      setEnabled((prev) => !prev);
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="ssa-settingsRow" aria-label="Employee service self-assignment">
      <div className="ssa-settingsRowCopy">
        <p className="ssa-settingsRowTitle">Allow employees to manage their own service assignments</p>
        <p className="ssa-settingsRowDesc">
          When enabled, employees can add or remove themselves from services they are eligible to
          perform at their assigned locations.
        </p>
      </div>
      <label className="ssa-settingsRowCheckbox" aria-label="Allow employees to manage their own service assignments">
        <input type="checkbox" checked={enabled} onChange={handleChange} disabled={saving} />
      </label>
    </section>
  );
};

export default EmployeeSelfServiceAssignmentSettingsRow;
